import AgencyHelper from 'features/Agency/agencyHelper';
import SystemHelper from 'features/System/systemHelper';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import CustomDateRangePicker, {
  dateFilter,
  getDateFilterOption,
} from 'general/components/Others/CustomDateRangePicker';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import UIHelper from 'general/helpers/UIHelper';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

PoaContractListFilterView.propTypes = {
  onCancel: PropTypes.func,
  onApply: PropTypes.func,
};

function PoaContractListFilterView({ onCancel, onApply, closeDropdown }) {
  // MARK: ---- PROPERTIES ----
  const [filterQ, setFilterQ] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [filterDateFilter, setFilterDateFilter] = useState(null);
  const [filterFrom, setFilterFrom] = useState('');
  const [filterTo, setFilterTo] = useState('');
  useEffect(() => {
    setFilterQ(SystemHelper.Filter.poaContractList.q);
    setFilterStatus(SystemHelper.Filter.poaContractList.status);
    setFilterDateFilter(SystemHelper.Filter.poaContractList.dateFilter);
    setFilterFrom(SystemHelper.Filter.poaContractList.from);
    setFilterTo(SystemHelper.Filter.poaContractList.to);
  }, [SystemHelper.Filter.poaContractList]);

  // MARK: ---- METHODS ----
  const handleApplyFilter = () => {
    SystemHelper.Filter.poaContractList = {
      ...SystemHelper.Filter.poaContractList,
      status: filterStatus,
      q: filterQ,
      dateFilter: filterDateFilter,
      from: filterFrom,
      to: filterTo,
    };
    if (onApply) onApply();
    if (closeDropdown) closeDropdown();
  };
  const handleClearFilter = () => {
    SystemHelper.Filter.poaContractList = {
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      q: '',
      status: '',
      dateFilter: dateFilter.baMuoiNgayGanNhat,
      from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
      to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
    };
    if (onCancel) onCancel();
    if (closeDropdown) closeDropdown();
  };

  return (
    <div className="py-4">
      <div className="row m-0 px-2">
        {/* tim kiem */}
        <div className="col-12 mb-4 px-2">
          <KTFormSearch
            name="search_filter"
            placeholder="Theo mã hợp đồng, số hợp đồng"
            value={filterQ}
            onSubmit={(text) => {
              setFilterQ(text);
            }}
          />
        </div>
        {/* trang thai */}
        <div className="col-12 mb-4 p-0 px-2">
          {UIHelper.buildFormLabel('Trạng thái')}
          <KTBSDropdown
            name="status_filter"
            toggleElement={
              <button
                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                type="button"
              >
                {_.find(AgencyHelper.Data.contractOptions, (item) => item.value === filterStatus)
                  ?.name ?? 'Tất cả'}
              </button>
            }
            selectedValue={SystemHelper.Filter.poaContractList.status}
            dropdownMenuItems={[
              { name: 'Tất cả', value: '' },
              ...AgencyHelper.Data.contractOptions,
            ]}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => {
              setFilterStatus(value);
            }}
            isDropdownForm={true}
          />
        </div>
        {/* khoang thoi gian */}
        <div className="col-12 mb-4 p-0 px-2">
          {UIHelper.buildFormLabel('Khoảng thời gian')}
          <CustomDateRangePicker
            inlineMode={true}
            toggleElementBorderRadius={5}
            initialValue={filterDateFilter}
            onPressSave={(selectedValue, startDate, endDate) => {
              setFilterDateFilter(selectedValue);
              setFilterFrom(startDate);
              setFilterTo(endDate);
            }}
          />
        </div>
      </div>

      {/* actions */}
      <div
        className="px-4 pt-4 pb-0 d-flex align-items-center justify-content-end gap-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Xóa bộ lọc', handleClearFilter)}
        {UIHelper.buildGreenButton('Áp dụng', handleApplyFilter)}
      </div>
    </div>
  );
}

export default PoaContractListFilterView;
